document.addEventListener('click', async function (e) {
    const btnModalEditarArea = e.target.closest('#btnModalEditarArea');
    if (!btnModalEditarArea) return;

    const idArea = btnModalEditarArea.getAttribute("data-id");
    const formEditar = document.querySelector("#formEditarArea");
    const modalEditar = document.querySelector("#ModalEditarArea");

    if (!formEditar || !idArea || !modalEditar) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta("Faltan parámetros para editar información del área.", "alerta-roja");
        }
        return;
    }
    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    const url = `/api/configuracion/areas/infoArea?idArea=${idArea}`;

    try {
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status}`);
        }

        const result = await response.json();
        const data = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("No se encontró información del usuario.", "alerta-roja");
            }
            setTimeout(() => {
                window.location.reload();
            }, 1500);
            return;
        }

        modalEditar.classList.add('modal--show');
        const inputIdArea = formEditar.querySelector('#idAreaEditarSelect');
        const inputNombreRol = formEditar.querySelector('#nombreAreaInput');
        const estado = formEditar.querySelector('#estadoArea');
        const checked = Number(data.estadoArea) === 1 ? 'checked' : '';
        const textoEstado = Number(data.estadoArea) === 1 ? 'ACTIVO' : 'INACTIVO';
        const divShitch = formEditar.querySelector('#divShitch');


        
        if (inputIdArea) inputIdArea.value = data.idArea || "";
        if (inputNombreRol) inputNombreRol.value = data.nombreArea || "";

        divShitch.innerHTML = `
                <span class="labelInfo">Estado:</span>
                <label class="switchEstado">
                    <input 
                        id="estado"
                        type="checkbox"
                        name="estadoArea"
                        value="${data.estadoArea}"
                        ${checked}
                    >
                    <span class="sliderEstado"></span>
                    <span class="textoEstado">
                        ${textoEstado}
                    </span>
                </label>
        `;

    } catch (error) {
        console.error("Error al obtener información del usuario:", error);

        if (typeof lanzarAlerta === "function") {
            lanzarAlerta("No se pudo cargar la información del usuario.", "alerta-roja");
        }
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEditarArea') {
        e.preventDefault();
        const formulario = e.target;
        const btnSubmit = formulario.querySelector('#btnEditarArea');
        const spinner = formulario.querySelector('#spinner');
        const formData = new FormData(formulario);
        if (!formulario || !btnSubmit || !spinner) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan parámetros para editar la área.", "alerta-roja");
            }
            return;
        }    
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';
        try {
            const respuesta = await fetch('/api/configuracion/areas/editar', {
                method: 'POST',
                body: formData
            });
            const json = await respuesta.json();
            const status = respuesta.status;
            const resultado = json.result;

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
                btnSubmit.disabled = false;
                spinner.style.display = 'none';
            } 
            if (!resultado.hayErrores) {
                lanzarAlerta("Área editada correctamente.", "alerta-verde");
                setTimeout(() => { window.location.reload(); }, 800);
            }

        } catch (error) {
            console.error("Error:", error);
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});